import { UploadStatusComponent } from "./UploadStatusComponent";

export default UploadStatusComponent;
